module.exports = "https://deal-img.imgix.net/consumer/modern/curated-avatar.006c7116.png";